<template>
  <router-view />
  <div v-if="toast.show" class="toast">{{ toast.message }}</div>
</template>

<script setup>
import { reactive, provide } from "vue";
/**
 * ✅ Toast
 */
const toast = reactive({
  show: false,
  message: ""
});
let toastTimer = null;

function showToast(msg) {
  toast.message = msg;
  toast.show = true;

  if (toastTimer) clearTimeout(toastTimer);
  toastTimer = setTimeout(() => {
    toast.show = false;
    toast.message = "";
  }, 2200);
}

provide("showToast", showToast);
</script>

<style>
body {
  margin: 0px;
}

/* toast */
.toast {
  position: fixed;
  right: 18px;
  bottom: 18px;
  background: rgba(17, 17, 17, 0.92);
  color: #fff;
  padding: 12px 14px;
  border-radius: 12px;
  font-size: 13px;
  z-index: 60;
}

.input {
  border: 1px solid #e6e8eb;
  border-radius: 10px;
  padding: 10px 10px;
  font-size: 13px;
  background: #fff;
  min-width: 240px;
}

.mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas,
    "Liberation Mono", "Courier New", monospace;
}
</style>
